import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { sendMessage } from 'actions'

import { border } from 'styles'
import { primary, placeholder } from 'styles/colors'

const Form = styled.form`
  flex-shrink: 0;
  border-top: ${border};
  padding: ${props => (props.small ? '10px' : '30px')};
  display: flex;
`

const Input = styled.input`
  flex-grow: 1;
  margin-right: 10px;
  background-color: #f8f8f8;
  border: 1px solid #523c6c;
  border-radius: 4px;
  padding: 13px 9px;

  &::placeholder {
    color: ${placeholder};
  }
`

const Button = styled.button`
  color: white;
  background-color: ${primary};
  border-radius: 4px;
  border: none;
  font-size: 16px;
  padding: 10px 0 11px;
  width: 90px;
  cursor: pointer;
`

class ChatField extends React.Component {
  state = {
    message: '',
  }

  sendMessage = e => {
    e.preventDefault()

    this.props.sendMessage(this.props.roomId, this.state.message)
    this.setState({ message: '' })
  }

  render() {
    return (
      <Form onSubmit={this.sendMessage} small={this.props.small}>
        <Input
          type="text"
          placeholder="Skriv melding her"
          value={this.state.message}
          onChange={e => this.setState({ message: e.target.value })}
          autoFocus
        />
        <Button type="submit">Send</Button>
      </Form>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = { sendMessage }

export default connect(mapStateToProps, mapDispatchToProps)(ChatField)



// WEBPACK FOOTER //
// ./src/components/chat/ChatField.js